import { API_URL, CapitalizeFirstWord } from "../../helpers/utils";
import axios from "../../helpers/axios";
import {
  catchHandler,
  dispatchError,
  dispatchLoading,
  dispatchToast,
  elseHandler,
  Reset,
} from "../../helpers/dispatch";
import {
  decryptByText,
  requestPayloadBodyFormate,
  responseDataFormate,
} from "../../helpers/bycrypt";
import { formatSecondsToHHMM } from "../../helpers/common";
import { NavigateFunction } from "react-router-dom";
import axiosInstance from "../../helpers/axios";



export const GetDashboardCountAPI =
  ({ start_date, end_date }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getDashboardCount", true);
    let params: any = {};

    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;

    axiosInstance
      .get(`/admin/dashboard-counts`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_DASHBOARD_COUNT",
            payload: result?.data,
          });
        } else {
          elseHandler(dispatch, "getDashboardCount", result);
          // navigate("/auth/login");
        }
        dispatchLoading(dispatch, "getDashboardCount", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getDashboardCount")(err);
        // navigate("/auth/login");
      });
  };

export const GetFinanceDashboardDataAPI =
  ({ today_date, start_date, end_date }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getFinanceDashboarCount", true);
    let params: any = {};

    if (today_date) params["today_date"] = today_date;
    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;

    axiosInstance
      .get(`/admin/finance-dashboard-count`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_FINANCE_DASHBOARD_DATA",
            payload: {
              total_overdue: result?.data?.total_overdue,
              total_pending: result?.data?.total_pending,
              total_received: result?.data?.total_received,
              accounts_approval_needed:
                result?.data?.accounts_approval_needed ?? 0,
            },
          });
        } else {
          elseHandler(dispatch, "getFinanceDashboarCount", result);
        }
        dispatchLoading(dispatch, "getFinanceDashboarCount", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getFinanceDashboarCount")(err);
      });
  };

export const GetFinanceDashboardMilestoneDataAPI =
  (
    { page, limit, today_date, start_date, end_date, status }: any,
    setHasMore: any,
  ) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getFinanceDashboarMilestone", true);
    let params: any = {};

    if (today_date) params["today_date"] = today_date;
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;
    if (status) params["status"] = status;

    axiosInstance
      .get(`/admin/finance-dashboard-milestone`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_FINANCE_DASHBOARD_MILESTONE_DATA",
            payload: {
              page: page,
              count: result?.data?.total,
              data: result?.data?.data,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.data?.length == limit);
          }
        } else {
          elseHandler(dispatch, "getFinanceDashboarMilestone", result);
        }
        dispatchLoading(dispatch, "getFinanceDashboarMilestone", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getFinanceDashboarMilestone")(err);
      });
  };

export const GetSalesDashboardDataAPI =
  ({ today_date, start_date, end_date }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getSalesDashboard", true);
    let params: any = {};

    if (today_date) params["today_date"] = today_date;
    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;

    axiosInstance
      .get(`/admin/sales-team-dashboard`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_SALES_DASHBOARD_DATA",
            payload: result?.data,
          });
        } else {
          elseHandler(dispatch, "getSalesDashboard", result);
        }
        dispatchLoading(dispatch, "getSalesDashboard", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getSalesDashboard")(err);
      });
  };


  export const GetProductionDashboardCountAPI =
  ({ start_date, end_date }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getProductionDashboardCount", true);
    let params: any = {};

    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;

    axiosInstance
      .get(`/admin/production-dashboard-count`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_PRODUCTION_DASHBOARD_COUNT",
            payload: result?.data,
          });
        } else {
          elseHandler(dispatch, "getProductionDashboardCount", result);
          // navigate("/auth/login");
        }
        dispatchLoading(dispatch, "getProductionDashboardCount", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getProductionDashboardCount")(err);
        // navigate("/auth/login");
      });
  };

export const GetInstallationDashboardCountAPI =
  ({ start_date, end_date }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getInstallationDashboardCount", true);
    let params: any = {};

    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;

    axiosInstance
      .get(`/admin/installation-dashboard-count`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_INSTALLATION_DASHBOARD_COUNT",
            payload: result?.data,
          });
        } else {
          elseHandler(dispatch, "getInstallationDashboardCount", result);
        }
        dispatchLoading(dispatch, "getInstallationDashboardCount", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getInstallationDashboardCount")(err);
      });
  };

export const GetDispatchDashboardCountAPI =
  ({ start_date, end_date }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getDispatchDashboardCount", true);
    let params: any = {};

    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;

    axiosInstance
      .get(`/admin/dispatch-dashboard-count`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_DISPATCH_DASHBOARD_COUNT",
            payload: result?.data,
          });
        } else {
          elseHandler(dispatch, "getDispatchDashboardCount", result);
        }
        dispatchLoading(dispatch, "getDispatchDashboardCount", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getDispatchDashboardCount")(err);
      });
  };

export const GetPrintingManagerDashboardDataAPI =
  () => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getPrintingManagerDashboardData", true);

    axiosInstance
      .get(`/admin/printing-manager-dashboard-count`, {
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_PRINTING_MANAGER_DASHBOARD_DATA",
            payload: result?.data,
          });
        } else {
          elseHandler(dispatch, "getPrintingManagerDashboardData", result);
        }
        dispatchLoading(dispatch, "getPrintingManagerDashboardData", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getPrintingManagerDashboardData")(err);
      });
  };

export const GetCustomerDashboardCountAPI =
  ({ start_date, end_date }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getCustomerDashboardCount", true);
    let params: any = {};

    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;

    axiosInstance
      .get(`/admin/customer-dashboard-count`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "GET_CUSTOMER_DASHBOARD_COUNT",
            payload: result?.data,
          });
        } else {
          elseHandler(dispatch, "getCustomerDashboardCount", result);
        }
        dispatchLoading(dispatch, "getCustomerDashboardCount", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getCustomerDashboardCount")(err);
      });
  };

const inFlightAttendanceRequests = new Map<string, Promise<any>>();
const lastAttendanceRequestTime = new Map<string, number>();

export const GetEmployeeAttendanceDashboardAPI =
  ({
    start,
    end,
    user,
    isSilent = false,
    force = false,
    limit,
  }: {
    start?: string;
    end?: string;
    user?: string;
    isSilent?: boolean;
    force?: boolean;
    limit?: number;
  }) =>
  async (dispatch: (action: any) => void) => {
    const requestKey = `${start || ""}_${end || ""}_${user || ""}_${limit || ""}`;

    // 1. If this exact API request is already in-flight, return the active promise - do not call again
    if (inFlightAttendanceRequests.has(requestKey)) {
      return inFlightAttendanceRequests.get(requestKey);
    }

    // 2. Prevent duplicate loop calls if called again within 1.5 seconds with identical parameters (unless force === true)
    const lastTime = lastAttendanceRequestTime.get(requestKey) || 0;
    if (!force && Date.now() - lastTime < 1500) {
      return;
    }

    if (!isSilent) {
      dispatchLoading(dispatch, "getEmployeeAttendanceDashboard", true);
    }
    let params: any = {};

    if (start) params["startDate"] = start;
    if (end) params["endDate"] = end;
    if (user) params["employeeId"] = user;

    const requestPromise = axiosInstance
      .get(`/admin/hr-dashboard-availability-all`, {
        params: { ...params, page: 1, limit: limit ?? 1000 },
        withCredentials: false,
      })
      .then((response) => {
        if (response?.data?.success) {
          const resData = response?.data?.data?.data;
          let finalPayload: any = [];
          
          if (Array.isArray(resData) && resData.length > 0 && Array.isArray(resData[0].attendance)) {
            const allDayNoteDates = new Set<string>();
            resData.forEach((userItem: any) => {
              if (Array.isArray(userItem.day_note_dates)) {
                userItem.day_note_dates.forEach((d: string) => allDayNoteDates.add(d));
              }
            });

            finalPayload = resData[0].attendance.map((att: any) => {
              let formattedTotal = att.total || att.total_time;
              
              if (!formattedTotal && att.created_at) {
                const start = new Date(att.created_at).getTime();
                const end = att.clockOut && att.updated_at ? new Date(att.updated_at).getTime() : Date.now();
                const diffSeconds = Math.floor((end - start) / 1000);
                if (diffSeconds > 0) {
                  formattedTotal = formatSecondsToHHMM(diffSeconds);
                }
              }

              return {
                ...att,
                user: {
                  _id: resData[0]._id,
                  first_name: resData[0].first_name,
                  last_name: resData[0].last_name,
                  profile_pic: resData[0].profile_pic,
                  isActive: resData[0].isActive,
                },
                day_note_dates: Array.from(allDayNoteDates),
                created_at: att.created_at,
                updated_at: att.updated_at,
                isPayrollApproved: att.isPayrollApproved ?? att.is_payroll_approved ?? resData[0]?.isPayrollApproved ?? resData[0]?.is_payroll_approved ?? false,
                total: formattedTotal || "00:00:00"
              };
            }).sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());

            finalPayload.day_note_dates = Array.from(allDayNoteDates);
            finalPayload.isPayrollApproved = resData[0]?.isPayrollApproved ?? resData[0]?.is_payroll_approved ?? false;
            finalPayload.isActive = resData[0]?.isActive;
          } else if (Array.isArray(resData)) {
            finalPayload = resData;
          } else {
            finalPayload = response?.data?.data || [];
          }

          dispatch({
            type: "GET_HR_ATTENDANCE_DATA",
            payload: finalPayload,
          });
        } else {
          if (!isSilent) {
            elseHandler(dispatch, "getEmployeeAttendanceDashboard", response?.data);
          }
        }
      })
      .catch((err) => {
        if (!isSilent) {
          catchHandler(dispatch, "getEmployeeAttendanceDashboard")(err);
        } else {
          if (err?.response?.status === 444) {
            Reset();
          }
        }
      })
      .finally(() => {
        inFlightAttendanceRequests.delete(requestKey);
        lastAttendanceRequestTime.set(requestKey, Date.now());
        if (!isSilent) {
          dispatchLoading(dispatch, "getEmployeeAttendanceDashboard", false);
        }
      });

    inFlightAttendanceRequests.set(requestKey, requestPromise);
    return requestPromise;
  };

export const UpdateEmployeeAttendanceAPI =
  (data: any) =>
  async (dispatch: (action: any) => void): Promise<boolean> => {
    dispatchLoading(dispatch, "updateEmployeeAttendance", true);
    return new Promise((resolve) => {
      axiosInstance
        .put(`/employee-attendance`, data)
        .then((response) => {
          if (response?.data?.success) {
            resolve(true);
          } else {
            elseHandler(dispatch, "updateEmployeeAttendance", response?.data);
            resolve(false);
          }
          dispatchLoading(dispatch, "updateEmployeeAttendance", false);
        })
        .catch((err) => {
          catchHandler(dispatch, "updateEmployeeAttendance")(err);
          resolve(false);
        });
    });
  };

export const AddBulkAttendanceLogAPI =
  (data: any) =>
  async (dispatch: (action: any) => void): Promise<boolean> => {
    dispatchLoading(dispatch, "addBulkAttendanceLog", true);
    return new Promise((resolve) => {
      axiosInstance
        .post(`/employee-attendance/bulk-manual-log`, data)
        .then((response) => {
          if (response?.data?.success) {
            resolve(true);
          } else {
            elseHandler(dispatch, "addBulkAttendanceLog", response?.data);
            resolve(false);
          }
          dispatchLoading(dispatch, "addBulkAttendanceLog", false);
        })
        .catch((err) => {
          catchHandler(dispatch, "addBulkAttendanceLog")(err);
          resolve(false);
        });
    });
  };

export const AddManualAttendanceLogAPI =
  (data: any) =>
  async (dispatch: (action: any) => void): Promise<boolean> => {
    dispatchLoading(dispatch, "addManualAttendanceLog", true);
    return new Promise((resolve) => {
      axiosInstance
        .post(`/employee-attendance/manual-log`, data)
        .then((response) => {
          if (response?.data?.success) {
            resolve(true);
          } else {
            elseHandler(dispatch, "addManualAttendanceLog", response?.data);
            resolve(false);
          }
          dispatchLoading(dispatch, "addManualAttendanceLog", false);
        })
        .catch((err) => {
          catchHandler(dispatch, "addManualAttendanceLog")(err);
          resolve(false);
        });
    });
  };

export const DeleteEmployeeAttendanceAPI =
  (data: { clockInId?: string; clockOutId?: string }) =>
  async (dispatch: (action: any) => void): Promise<boolean> => {
    dispatchLoading(dispatch, "deleteEmployeeAttendance", true);
    return new Promise((resolve) => {
      axiosInstance
        .delete(`/employee-attendance`, { data })
        .then((response) => {
          if (response?.data?.success) {
            resolve(true);
          } else {
            elseHandler(dispatch, "deleteEmployeeAttendance", response?.data);
            resolve(false);
          }
          dispatchLoading(dispatch, "deleteEmployeeAttendance", false);
        })
        .catch((err) => {
          catchHandler(dispatch, "deleteEmployeeAttendance")(err);
          resolve(false);
        });
    });
  };

export const GetHRDashboardIncompleteSetupAPI =
  () =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getHRDashboardIncompleteSetup", true);
    return new Promise((resolve) => {
      axiosInstance
        .get(`/admin/hr-dashboard-incomplete-setup`)
        .then((response) => {
          let result = responseDataFormate(response?.data);
          if (result?.success) {
            resolve(result.data);
          } else {
            elseHandler(dispatch, "getHRDashboardIncompleteSetup", result);
            resolve(null);
          }
          dispatchLoading(dispatch, "getHRDashboardIncompleteSetup", false);
        })
        .catch((err) => {
          catchHandler(dispatch, "getHRDashboardIncompleteSetup")(err);
          resolve(null);
        });
    });
  };

export const GetHRDashboardAutoClockOutCountAPI =
  (query: any = {}) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getHRDashboardAutoClockOutCount", true);
    return new Promise((resolve) => {
      axiosInstance
        .get(`/admin/hr-dashboard-auto-clock-out-count`, { params: query })
        .then((response) => {
          let result = responseDataFormate(response?.data);
          if (result?.success) {
            resolve(result.data);
          } else {
            elseHandler(dispatch, "getHRDashboardAutoClockOutCount", result);
            resolve(null);
          }
          dispatchLoading(dispatch, "getHRDashboardAutoClockOutCount", false);
        })
        .catch((err) => {
          catchHandler(dispatch, "getHRDashboardAutoClockOutCount")(err);
          resolve(null);
        });
    });
  };

export const GetHRDashboardAvailabilityAPI =
  (params: any, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getHRDashboardAvailability", true);
    return new Promise((resolve) => {
      axiosInstance
        .get(`/admin/hr-dashboard-availability`, { params })
        .then((response) => {
          let result = responseDataFormate(response?.data);
          if (result?.success) {
            const responseData = result.data || {};
            const apiData = Array.isArray(responseData) ? responseData : (responseData.data || []);
            
            if (setHasMore) {
              if (responseData.total !== undefined) {
                // Backend provided total, page, limit
                const page = responseData.page || 1;
                const limit = responseData.limit || 12;
                const fetchedCount = ((page - 1) * limit) + apiData.length;
                setHasMore(fetchedCount < responseData.total);
              } else {
                // Fallback to length check
                const limit = params?.limit ? parseInt(params.limit) : 25;
                setHasMore(apiData.length === limit);
              }
            }
            resolve({ data: apiData, total: responseData.total || apiData.length });
          } else {
            elseHandler(dispatch, "getHRDashboardAvailability", result);
            resolve({ data: [], total: 0 });
          }
          dispatchLoading(dispatch, "getHRDashboardAvailability", false);
        })
        .catch((err) => {
          catchHandler(dispatch, "getHRDashboardAvailability")(err);
          resolve({ data: [], total: 0 });
        });
    });
  };

export const GetHRDashboardLeavesSummaryAPI =
  () =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getHRDashboardLeavesSummary", true);
    return new Promise((resolve) => {
      axiosInstance
        .get(`/admin/hr-dashboard-leaves-summary`)
        .then((response) => {
          let result = responseDataFormate(response?.data);
          if (result?.success) {
            resolve(result.data);
          } else {
            elseHandler(dispatch, "getHRDashboardLeavesSummary", result);
            resolve(null);
          }
          dispatchLoading(dispatch, "getHRDashboardLeavesSummary", false);
        })
        .catch((err) => {
          catchHandler(dispatch, "getHRDashboardLeavesSummary")(err);
          resolve(null);
        });
    });
  };
export const GetAllHRDashboardAvailabilityAPI =
  (params: any, setHasMore?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getAllHRDashboardAvailability", true);
    return new Promise((resolve) => {
      axiosInstance
        .get(`/admin/hr-dashboard-availability-all`, { params })
        .then((response) => {
          let result = responseDataFormate(response?.data);
          if (result?.success) {
            const responseData = result.data || {};
            const apiData = Array.isArray(responseData) ? responseData : (responseData.data || []);
            
            if (setHasMore) {
              if (responseData.total !== undefined) {
                // Backend provided total, page, limit
                const page = responseData.page || 1;
                const limit = responseData.limit || 12;
                const fetchedCount = ((page - 1) * limit) + apiData.length;
                setHasMore(fetchedCount < responseData.total);
              } else {
                // Fallback to length check
                const limit = params?.limit ? parseInt(params.limit) : 25;
                setHasMore(apiData.length === limit);
              }
            }
            resolve({ data: apiData, total: responseData.total || apiData.length });
          } else {
            elseHandler(dispatch, "getAllHRDashboardAvailability", result);
            resolve({ data: [], total: 0 });
          }
          dispatchLoading(dispatch, "getAllHRDashboardAvailability", false);
        })
        .catch((err) => {
          catchHandler(dispatch, "getAllHRDashboardAvailability")(err);
          resolve({ data: [], total: 0 });
        });
    });
  };

export const GetEmployeeDropdownListAPI =
  (
    params: {
      page?: number;
      limit?: number;
      search?: string;
      isActive?: boolean;
    },
    cb: (result: { success: boolean; data?: any; message?: string }) => void
  ) =>
  async (dispatch: any) => {
    try {
      axiosInstance
        .get(`/admin/employee-dropdown-list`, { params })
        .then((response) => {
          let result = responseDataFormate(response?.data);
          if (result?.success) {
            cb({ success: true, data: result.data });
          } else {
            cb({ success: false, message: result?.message || "Failed to fetch employees" });
          }
        })
        .catch((error) => {
          cb({ success: false, message: error.message || "Network Error" });
        });
    } catch (err: any) {
      cb({ success: false, message: err.message || "Network Error" });
    }
  };
